export function extractValues(obj = {}) {
	const result = {};

	const getValue = (node) => {
		if (Array.isArray(node)) {
			return node.map((item) => {
				let current = item;
				while (current && typeof current === "object" && "value" in current) {
					current = current.value;
				}
				if (typeof current === "string") {
					return current.trim();
				}
				return current;
			});
		}
		let current = node;
		while (current && typeof current === "object" && "value" in current) {
			current = current.value;
		}
		if (typeof current === "string") {
			return current.trim();
		}
		return current;
	};

	for (const key in obj) {
		result[key] = getValue(obj[key]);
	}

	return result;
}
